import { render, staticRenderFns } from "./copy-notification.vue?vue&type=template&id=a621a228&scoped=true&"
import script from "./copy-notification.js?vue&type=script&lang=js&"
export * from "./copy-notification.js?vue&type=script&lang=js&"
import style0 from "./copy-notification.scss?vue&type=style&index=0&id=a621a228&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a621a228",
  null
  
)

export default component.exports